<template>    

<div class="">


</div>

<div class="container">
    <div class="row">
        <div class="col-12">
            <div class="card my-3">
                <div class="card-header">
                    Editar
                    <category-create></category-create>
                </div>
                <div class="card-body">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th width="10px">ID</th>
                            <th>titulo</th>
                            <th >Editar</th>
                            <th >Eliminar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="category in v_categories" v-bind:key="category.id">
                            <td>{{ category.id }}</td>
                            <td>{{ category.title }} -{{category.lang }}</td>
                            <td width="10px">
                                <category-edit :category="category"></category-edit>
                            </td>
                            <td width="10px">
                                <button @click="borrar_category(category.id)" class="btn btn-sm btn-danger">
                                    <img src="../assets/trash-can.svg" width="15" alt="">
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </div>
        </div>
    </div>
</div>
    
</template>
<script>

import { useStore } from 'vuex';
import {useToast} from 'vue-toastification'
import {computed, ref, onMounted} from 'vue'
import categoryEdit from '@/components/web/category/categoryEdit.vue';
import categoryCreate from '@/components/web/category/categoryCreate.vue'

export default{
    name:'categoryView',
    components:{categoryEdit,categoryCreate},
    setup(){
        const store = useStore();
        const toast = useToast();
        const modal = ref(false);

        const modal_delete = ref(false);

        const v_categories = computed(()=>store.state.v_categories)
        onMounted(()=>{
                store.dispatch('nic/v_actions_nics')
                store.dispatch('v_action_categories')              
            })
//store.dispatch('v_action_categories')
        const borrar_category = (id_category) => {
            toast.warning('funcionalidad no habilitada :( ')
            console.log('test'+id_category)
        }

        return{
            borrar_category,
            modal,
            v_categories,
            modal_delete
        }
    }
}
</script>